import { useState } from "react";
import { toast } from "sonner";
import { Loader2, UploadCloud } from "lucide-react";
import { api, errMsg } from "../../lib/api";

const KEY = "spore.liveUrl";

export const PushLivePanel = ({ count }) => {
  const [url, setUrl] = useState(() => localStorage.getItem(KEY) || "");
  const [passcode, setPasscode] = useState("");
  const [busy, setBusy] = useState(false);
  const [last, setLast] = useState(null);

  const push = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/push-live", { url, passcode });
      localStorage.setItem(KEY, url);
      setLast(data);
      toast.success(`Live site updated: ${data.updated} objects refreshed, ${data.created} added`);
    } catch (err) {
      toast.error(errMsg(err, "Could not push to the live site"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form data-testid="push-live-panel" onSubmit={push} className="border border-cyan-400/30 bg-slate-950/60 p-5">
      <p className="lab-label !text-cyan-300">Push content to the live site</p>
      <p className="mt-2 text-sm text-slate-400">
        Publishing ships the code, not the data. After editing objects, memories, voices or the Scientist's lines here, push them to the
        public address so the exhibit plays exactly what you hear in this preview ({count} objects, case file, narration, voices).
      </p>
      <div className="mt-4 grid gap-3 sm:grid-cols-[1fr_220px_auto]">
        <input data-testid="push-live-url" value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://your-live-address.com" required className="lab-input w-full font-mono text-sm" />
        <input data-testid="push-live-passcode" type="password" value={passcode} onChange={(e) => setPasscode(e.target.value)} placeholder="live site passcode" required className="lab-input w-full font-mono text-sm" />
        <button data-testid="push-live-button" type="submit" disabled={busy} className="lab-btn-primary disabled:opacity-60">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <UploadCloud size={16} />} {busy ? "Pushing..." : "Push to live"}
        </button>
      </div>
      {last && (
        <p data-testid="push-live-result" className="mt-3 font-mono text-xs uppercase tracking-widest text-cyan-300">
          Done · {last.target} · {last.total} objects live · audio is re-rendering there now
        </p>
      )}
    </form>
  );
};
